<template>
  <div>
    <img
      v-if="value"
      class="is_set"
      title="YES"
      alt="YES"
      src="../assets/images/is-set.svg"
    >
    <img
      v-else
      class="is_set"
      title="NO"
      alt="NO"
      src="../assets/images/isnot-set.svg"
    >
  </div>
</template>

<script>
export default {
  name: 'app-graphic-image',
  props: {
    value: {
      type: Boolean
    },
  }
}
</script>
